import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FeesStepInstance } from 'services/professional/step/step.interface';
import { StepService } from 'services/professional/step/step.service';
import { MessageQueryService } from '@certemy/ui-components';
import { FeesFormField } from 'components/organization-certification/step/fee/fee-step.interface';
import { FeatureToggleService, FEATURES } from 'features/feature-toggle';
import { take, filter } from 'rxjs/operators';
import { FeeFormOptionsForPayment } from 'features/payment-form/payment-form.interface';

export function getFeeFormOptionsForPayment(feesFormFields: FeesFormField[]): FeeFormOptionsForPayment[] {
  return feesFormFields.reduce((optionsInfo, field) => {
    const optionsMap = field.options
      .filter(option => option.quantity)
      .map(option => ({ optionInstanceId: option.optionInstanceId, quantity: option.quantity }));
    return [...optionsInfo, ...optionsMap];
  }, []);
}

export enum FeesScreens {
  Initial,
  Payment,
  FileUpload,
  ThirdParty,
  ResetConfirm,
  VoucherConfirm,
}

@Component({
  selector: 'cm-fees-details',
  templateUrl: './fees-details.modal.component.html',
  styleUrls: ['./fees-details.modal.component.scss'],
})
export class FeesDetailsComponent implements OnInit {
  @Input() step: FeesStepInstance;
  @Input() workflowTypeId: number;
  @Output() updateStep = new EventEmitter();
  @Output() toggleMode = new EventEmitter();
  readonly FeesScreens = FeesScreens;
  readonly FEATURES = FEATURES;
  screen = FeesScreens.Initial;
  hasFeatureVouchers = false;
  isPreviousPaymentPage = false;
  voucherValue: string;

  constructor(
    public activeModal: NgbActiveModal,
    private stepService: StepService,
    private messageQueryService: MessageQueryService,
    private featureToggleService: FeatureToggleService,
  ) {}

  ngOnInit() {
    this.featureToggleService
      .hasFeatures(FEATURES.VOUCHERS)
      .pipe(
        take(1),
        filter(hasFeature => hasFeature),
      )
      .subscribe(() => {
        this.hasFeatureVouchers = true;
      });
  }

  confirmVoucherValueChange(voucherValue: string) {
    if (voucherValue) {
      this.screen = FeesScreens.VoucherConfirm;
    }
    this.voucherValue = voucherValue;
  }

  onBackFromPayment() {
    this.isPreviousPaymentPage = true;
    this.screen = FeesScreens.Initial;
  }

  onSwitchScreen(screen: FeesScreens) {
    this.isPreviousPaymentPage = false;
    this.screen = screen;
  }

  goToInitialPage() {
    this.toggleMode.emit();
    this.onSwitchScreen(FeesScreens.Initial);
  }

  onResetConfirm() {
    this.stepService.resetStep(this.step.step_instance_id).subscribe(() => {
      this.updateStep.emit();
      this.messageQueryService.addMessage('Step has been successfully reset');
      this.goToInitialPage();
    });
  }
}
